import React, { Component } from 'react';
import { connect } from 'react-redux';

class NotAuthorize extends Component {
  componentWillMount() {
  }

  render() {
    return (
      <div className='align-items-center d-flex justify-content-center' style={{ height: '100vh', width: '100vw' }}>You dont have permission to view this page </div>
    );
  }
}

export default connect(
  state => ({
  })
)(NotAuthorize);

